import React from 'react';
import PropTypes from 'prop-types';

import colors from 'theme/_colors.scss';

const IconComputer = ({ width = 32, height = 32, viewBox = '0 0 32 32', color = colors.nero }) => {
    return <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M14 11H10V12H6V11H2L0 14L1 15H15L16 14L14 11ZM14 5.86V1H2V10H14V5.86ZM12 5.86V8H4V3H12V5.86Z' fill={color} />
    </svg>;
};

IconComputer.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default React.memo(IconComputer);
